import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { currentCategoryFAQQuestionsSelector } from '../../../../redux/product-listing/product-listing.selectors';
import { SwagFAQComponent } from './swag-faq';
const mapStateToProps = createStructuredSelector({
  questions: currentCategoryFAQQuestionsSelector
});
export const SwagFAQ = connect(mapStateToProps)(SwagFAQComponent);